// ============================================================
// 前端全局配置常量
// ============================================================

/**
 * 客户支持邮箱（公开展示于页脚与法律页面，
 * 需与 Waffo 后台提交的联系邮箱、收据邮箱保持一致）
 */
export const SUPPORT_EMAIL = 'yinmin66880@gmail.com';
